import React, { useEffect, useState, useCallback } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { PolicyChangeService } from 'gw-capability-gateway';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { MLActivityDateUtil } from 'ml-portals-util-react';

import styles from '../ActivityReportsComponent/ActivityReportsComponent.module.scss';
import messages from './MLIncompletePendedReportComponent.messages';
import metadata from './MLIncompletePendedReportComponent.metadata.json5';

const MLIncompletePendedReportComponent = (props) => {
    const {
        rowLimit,
        isDashboard,
        isCompactView,
        getCustomerDisplayNameRevert,
        history,
        convertLocalDateToDate
    } = props;
    const translator = useTranslator();

    const {
        getActivityDate
    } = MLActivityDateUtil();

    const { authHeader } = useAuthentication();

    const [isLoading, updateIsLoading] = useState(false);
    const [filteredJobs, updateFilteredJobs] = useState([]);
    const [resultsRowCount, updateResultsRowCount] = useState(0);
    const [filterData, updateFilterData] = useState({});

    const loadIncompletePendedChangesData = useCallback(async (filteringData) => {
        updateIsLoading(true);

        const response = isDashboard
            ? await PolicyChangeService.getMostRecentIncompletePendedChangesForCurrentUser(rowLimit, filteringData, authHeader)
            : await PolicyChangeService.getMostRecentIncompletePendedChangesForCurrentUser(null, filteringData, authHeader);

        updateFilteredJobs(response);
        updateIsLoading(false);
        updateResultsRowCount(response.length);
    }, [authHeader, isDashboard, rowLimit]);

    useEffect(() => {
        loadIncompletePendedChangesData(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onFilter = () => {
        loadIncompletePendedChangesData(filterData);
    };

    const onClearFilters = () => {
        updateFilterData({});
    };

    const renderEffectiveDateCell = (item) => {
        return item.policyEffectiveDate_ML ? <span>{getActivityDate(item.policyEffectiveDate_ML)}</span> : '-';
    };

    const renderCustomerName = (item) => {
        if(_.isUndefined(item.accountHolder_ML)) {
            return '-'
        }
        return (
            <Link to={`/accounts/${item.accountNumber}/summary`} className={styles.linkCellValue}>
                {_.capitalize(getCustomerDisplayNameRevert(item.accountHolder_ML))}
            </Link>
        )
    };

    const renderProductCell = (item) => {
        return _.get(item, 'product.productName') ? item.product.productName : '-';
    };

    const renderPolicyCell = (item) => {
        if(_.isUndefined(item.policyNumber)) {
            return '-'
        }
        return (
            <Link to={`/policies/${item.policyNumber}/summary`} className={styles.linkCellValue}>
                {item.policyNumber}
            </Link>
        )
    };

    const renderDescriptionCell = (item) => {
        return item.initiator_ML ? item.initiator_ML : '-';
    };

    const onViewAllButtonClicked = () => {
        const reportView = 'incomplete-pended-report';
        history.push('/activity-reports', {reportView : reportView} );
    }

    const overrideProps = {
        statusDesc: {
            visible: isLoading,
            content: translator(messages.loading)
        },
        mlJobResultsFilterComponent: {
            visible: !isCompactView,
            filterData,
            onFilter,
            onClearFilters,
            resultsRowCount,
            updateFilterData,
            hideFields: ['PRODUCT']
        },
        mlIncompletePendedReportTable: {
            data: _.orderBy(filteredJobs, 'policyEffectiveDate_ML', 'asc'),
            visible: !isLoading,
            defaultPageSize: rowLimit,
            noDataText: translator(messages.noIncompletePendedFound),
            showPagination: !isCompactView
        },
        viewAllPolicyChangesButton: {
            visible: isDashboard,
            onClick: onViewAllButtonClicked,
            mlTagManagerLinkClick: "Dashboard_activityReport_viewAll_incompletePendedReports"
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            renderEffectiveDateCell,
            renderCustomerName,
            renderProductCell,
            renderPolicyCell,
            renderDescriptionCell
        },
        resolveClassNameMap: styles
    };
    
    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

MLIncompletePendedReportComponent.propTypes = {
    showAgentChanges: PropTypes.bool.isRequired,
    rowLimit: PropTypes.number.isRequired,
    isDashboard: PropTypes.bool.isRequired,
    isCompactView: PropTypes.bool.isRequired,
    getCustomerDisplayNameRevert: PropTypes.func.isRequired,
    history: PropTypes.shape({push: PropTypes.func}).isRequired,
    convertLocalDateToDate: PropTypes.func.isRequired
}

export default withRouter(withViewModelService(MLIncompletePendedReportComponent));
